import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatFormField, MatSuffix } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/autocomplete';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
  imports: [
    MatFormField,
    MatSelect,
    FormsModule,
    MatOption,
    NgClass,
    MatSuffix,
  ],
})
export class SelectComponent implements OnInit {
  @Input() selectedOptionId!: string;
  @Input() questions!: any[];
  @Input() firstStudent: any;
  @Input() isFilterOpen = false;
  @Input() placeholder = '';
  @Output() questionSelected = new EventEmitter<string>();
  constructor() {}
  ngOnInit(): void {
    if (this.questions) this.selectedOptionId = this.questions[0].id;
  }

  /**
   * Method to emit the selected option.
   * @param questionId string, id of the object selected.
   */
  getQuestionId(questionId: string) {
    this.selectedOptionId = questionId;
    this.questionSelected.emit(questionId);
  }

  /**
   * Method to get the correct text given any object.
   * @param question an object, can be type User, quizQuestions or ProgressByStudent.
   * @returns the text of the option, statement or name.
   */
  getStatement(question: any): string {
    if (question.firstName) return question.firstName + ' ' + question.lastName;
    else if (question.user_first_name)
      return (
        `${question.user_first_name} ${question.user_last_name}`.trim() +
        ` (${question.user_email})`
      );
    else return question.statement;
  }

  /**
   * Method to get the correct text given any object.
   * @param question an object, can be type User, quizQuestions or ProgressByStudent.
   * @returns the id of the option.
   */
  getID(question: any): string {
    if (question.id) return question.id;
    else return question.user_id;
  }
}
